import { i18n } from '@/lib/i18n'

/**
 * Mô tả lịch chạy của trigger `schedule` — khớp isDue() ở backend
 * (automation-cron-scheduler.ts), múi giờ Asia/Ho_Chi_Minh.
 */
// Mảng 7 phần tử có chỉ số là getter → `.map` / `[i]` luôn lấy bản dịch theo ngôn ngữ hiện tại.
export const WEEKDAYS: string[] = (() => {
  const a: string[] = []
  a.length = 7
  for (let i = 0; i < 7; i++) Object.defineProperty(a, i, { enumerable: true, get: () => i18n.t(`autoCore:schedule.weekdays.${i}`) })
  return a
})()

/**
 * Tần suất hiệu lực. Rule cũ dùng everyValue/everyUnit → trả '' để giao diện
 * KHÔNG ghi đè cho tới khi người dùng thực sự đổi (engine vẫn hiểu cấu hình cũ).
 */
export function tanSuat(c: Record<string, unknown>): string {
  return String(c.frequency || (c.everyUnit ? '' : 'daily'))
}

/** Câu mô tả lịch bằng tiếng Việt. */
export function scheduleSummary(c: Record<string, unknown>): string {
  const at = String(c.atTime || '09:00')
  const f = tanSuat(c)
  if (!f) {
    const n = Number(c.everyValue) || 1
    const u = String(c.everyUnit)
    return u === 'days' ? i18n.t('autoCore:schedule.summary.everyDays', { n, at }) : u === 'hours' ? i18n.t('autoCore:schedule.summary.everyHours', { n }) : i18n.t('autoCore:schedule.summary.everyMinutesLegacy', { n })
  }
  switch (f) {
    case 'minutes': return i18n.t('autoCore:schedule.summary.minutes', { n: Number(c.everyMinutes) || 5 })
    case 'hourly': return i18n.t('autoCore:schedule.summary.hourly', { minute: Number(c.minute) || 0 })
    case 'weekly': return i18n.t('autoCore:schedule.summary.weekly', { day: WEEKDAYS[Number(c.weekday ?? 1)] ?? WEEKDAYS[1], at })
    case 'monthly': return i18n.t('autoCore:schedule.summary.monthly', { day: Number(c.dayOfMonth) || 1, at })
    default: return i18n.t('autoCore:schedule.summary.daily', { at })
  }
}

/** Biểu thức cron tương đương (chỉ để đối chiếu, engine không đọc chuỗi này). */
export function scheduleCron(c: Record<string, unknown>): string {
  const [h, m] = String(c.atTime || '09:00').split(':').map(Number)
  switch (tanSuat(c) || 'daily') {
    case 'minutes': return `*/${Number(c.everyMinutes) || 5} * * * *`
    case 'hourly': return `${Number(c.minute) || 0} * * * *`
    case 'weekly': return `${m || 0} ${h || 0} * * ${Number(c.weekday ?? 1)}`
    case 'monthly': return `${m || 0} ${h || 0} ${Number(c.dayOfMonth) || 1} * *`
    default: return `${m || 0} ${h || 0} * * *`
  }
}
